
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux' // Redux 사용 시
import { getIsLoggedIn, getAllUserInfo } from 'store/Slices/user'

const PrivateRoute = () => {
    const isLogin = useSelector(getIsLoggedIn)
    const { userInfo } = useSelector(getAllUserInfo)
    const { isTutor } = userInfo
    const location = useLocation()

    // 인증되지 않은 경우 로그인 페이지로 리다이렉트
    if (!isLogin) {
        return <Navigate to="/login" replace />
    }

    // 강사는 마이페이지와 비밀번호 변경 페이지만 접근 가능
    if (isTutor && location.pathname !== '/tutor-mypage' && location.pathname !== '/accounts/password') {
        return <Navigate to="/tutor-mypage" replace />
    }

    // 일반 사용자(강사 아님)가 강사 전용 페이지 접근 시 메인으로 리다이렉트
    if (!isTutor && location.pathname === '/tutor-mypage') {
        return <Navigate to="/main" replace />
    }

    // 권한이 있으면 자식 라우트를 렌더링
    return <Outlet />
}

export default PrivateRoute